
import { Component, Vue } from 'vue-property-decorator'
import { TransTopReq } from '@/api/admin/risk'
import InputSear from '@/views/components/InputSear.vue'
import countrycode from '@/common/countrycode'
import JsonViewer from 'vue-json-viewer'
import { getTableSetting, setTableSetting } from '@/libs/util'
import { tableSettingModel } from '@/libs/config'
import {mapState} from "vuex";
@Component({
  components: {
    InputSear,
    JsonViewer
  },
  computed: {
    ...mapState({
      currencyList: state => state.app.globalCurrencyList
    }),
  },
})
export default class UserList extends Vue {
  loading: boolean = false
  TransTopReqTimer: any
  select = { countrycode }
  tableSetting: any = {}
  userTagDetails = {
    show: false,
    data: {
      user_tag: 0
    }
  }
  table = {
    total_num: 0, //统计人数
    total_pay: 0, //今日转入
    total_put: 0, //今日转出
    params: {
      mod: 'root',
      platid: 0,
      platids: [],
      app_id: 0,
      app_name: '',
      platform: 0,
      app_ids: [],
      param: {
        _mod: 'manager',
        _func: 'GetUserList',
        _param: {
          app_id: 0,
          general: -1,
          pack_no: -1,
          phone_code1: '',
          phone_code: 0,
          phone: '',
          ali_card: '',
          bank_card: '',
          card_name: '',
          last_ip: '',
          register_ip: '',
          mac_account: '',
          stime: 0,
          etime: 0,
          page: 1,
          limit: 100,
          is_active: 0,
          is_bind_superior: 0,
          is_online: 0,
          is_pay: 0,
          is_pid: 0,
          job_no: 0,
          last_city: '',
          last_login_time: 0,
          os_type: -1,
          pid: 0,
          register_city: '',
          user_id: null,
          user_status: 0,
          user_tag: [],
          user_type: 0
        }
      }
    },
    data: [],
    children: [],
    columns: [
      { type: 'index', title: '序号', width: 50, align: 'center' },
      {
        key: 'platid',
        align: 'center',
        width: 68,
        resizable: true,
        render: (h, params) => {
          let item: any = this.getPlatInfo(params.row)
          return h('span', item.name)
        },
        renderHeader: (h, params) =>
          (this as any).renderHeader(h, '所属分组', '显示对应盘口的所属平台')
      },
      {
        key: 'plat_name',
        align: 'center',
        width: 68,
        resizable: true,
        render: (h, params) => {
          let item: any = this.getAppInfo(params.row)
          return h('span', item.appName || '')
        },
        renderHeader: (h, params) =>
          (this as any).renderHeader(h, '平台名称', '显示对应盘口')
      },
      {
        key: 'user_id',
        align: 'center',
        width: 68,
        resizable: true,
        renderHeader: (h, params) => {
          return (this as any).renderHeader(
            h,
            '玩家ID',
            '显示该条信息对应玩家的ID；'
          )
        }
      },
      {
        key: 'name',
        align: 'center',
        width: 68,
        resizable: true,
        renderHeader: (h, params) => {
          return (this as any).renderHeader(
            h,
            '玩家昵称',
            '显示该条信息对应玩家的昵称；'
          )
        }
      },
      {
        key: 'os_type',
        align: 'center',
        width: 68,
        resizable: true,
        render: (h, params) => {
          let arr = ['网页', '安卓', 'IOS', '未知']
          return h('span', arr[params.row.os_type - 1])
        },
        renderHeader: (h, params) => {
          return (this as any).renderHeader(
            h,
            '注册途径',
            '玩家使用的移动设备(IOS、安卓、网页)'
          )
        }
      },
      {
        key: 'lang_type',
        align: 'center',
        width: 68,
        resizable: true,
        renderHeader: (h, params) => {
          return (this as any).renderHeader(
              h,
              '多语言分类',
              '显示该条信息对应的语言；'
          )
        },
        render: (h, params) => {
          return h("span", this.langFilter(params.row.lang_type));
        }
      },
      {
        key: 'currency_type',
        align: 'center',
        width: 68,
        resizable: true,
        renderHeader: (h, params) =>
            this.renderHeader(h,
                '货币分类',
                '显示该条信息对应的货币;'
            )
      },
      {
        key: 'pack_no',
        align: 'center',
        width: 68,
        resizable: true,
        render: (h, params) => {
          let str = params.row.user_type == 0 ? '会员' : '代理'
          return h('span', str)
        },
        renderHeader: (h, params) => {
          return (this as any).renderHeader(h, '用户类型', '显示该玩家用户类型')
        }
      },
      {
        key: 'pack_name',
        align: 'center',
        width: 100,
        resizable: true,
        render: (h, params) => {
          let str = params.row.pack_name + '(' + params.row.pack_no + ')'
          return h('span', str)
        },
        renderHeader: (h, params) => {
          return (this as any).renderHeader(
            h,
            '所属子商户',
            '显示该玩家所属的子商户'
          )
        }
      },
      {
        key: 'general',
        align: 'center',
        width: 100,
        resizable: true,
        render: (h, params) => {
          let str = params.row.general_name + '(' + params.row.general + ')'
          return h('span', str)
        },
        renderHeader: (h, params) => {
          return (this as any).renderHeader(
            h,
            '所属商户',
            '显示该条玩家所归属的商户信息；信息格式：商户名称+商户号'
          )
        }
      },
      // {
      // 	key: 'job_no',
      // 	align: 'center',
      // 	width: 68,
      // 	resizable: true,
      // 	render: (h, params) => {
      // 		let str = params.row.job_name + '(' + params.row.job_no + ')';
      // 		return h('span', str);
      // 	},
      // 	renderHeader: (h, params) => {
      // 		return (this as any).renderHeader(h, '所属客服', '显示该条玩家所归属的客服信息；信息格式：客服名称+客服号');
      // 	},
      // },
      {
        key: 'is_online',
        align: 'center',
        width: 68,
        resizable: true,
        render: (h, params) => {
          let str = params.row.is_online ? '在线' : '离线'
          return h(
            'span',
            {
              style: {
                color: params.row.is_online ? '#4ED221' : ''
              }
            },
            str
          )
        },
        renderHeader: (h, params) => {
          return (this as any).renderHeader(
            h,
            '在线状态',
            '显示当前该玩家是否在线；'
          )
        }
      },
      {
        key: 'status',
        align: 'center',
        width: 68,
        resizable: true,
        render: (h, params) => {
          let str = params.row.status ? '封号' : '正常'
          return h(
            'span',
            {
              style: {
                color: params.row.status ? 'red' : ''
              }
            },
            str
          )
        },
        renderHeader: (h, params) => {
          return (this as any).renderHeader(
            h,
            '账号状态',
            '显示当前该玩家是否在线；'
          )
        }
      },
      {
        key: 'point',
        align: 'center',
        width: 68,
        resizable: true,
        render: (h, params) => {
          return h(
            'span',
            ((params.row.point + params.row.bank_point) / 10000).toFixed(2)
          )
        },
        renderHeader: (h, params) => {
          return (this as any).renderHeader(
            h,
            '账户余额',
            '账户余额：钱包金额+银行余额=账户余额'
          )
        }
      },
      // {
      //   key: 'day_pay',
      //   align: 'center',
      //   width: 68,
      //   resizable: true,
      //   render: (h, params) => {
      //     return h('span', (params.row.day_pay / 10000).toFixed(2))
      //   },
      //   renderHeader: (h, params) => {
      //     return (this as any).renderHeader(
      //       h,
      //       '今日转入',
      //       '显示玩家当天的累计转入金额；'
      //     )
      //   }
      // },
      {
        key: 'day_give',
        align: 'center',
        width: 68,
        resizable: true,
        render: (h, params) => {
          return h('span', (params.row.day_give / 10000).toFixed(2))
        },
        renderHeader: (h, params) => {
          return (this as any).renderHeader(
            h,
            '今日赠送',
            '显示玩家当天的累计被系统赠送的金额'
          )
        }
      },
      // {
      //   key: 'day_puy',
      //   align: 'center',
      //   width: 68,
      //   resizable: true,
      //   render: (h, params) => {
      //     return h('span', (params.row.day_puy / 10000).toFixed(2))
      //   },
      //   renderHeader: (h, params) => {
      //     return (this as any).renderHeader(
      //       h,
      //       '今日转出',
      //       '显示玩家当天的累计转出金额'
      //     )
      //   }
      // },
      // {
      // 	key: 'history_pay',
      // 	align: 'center',
      // 	width: 68,
      // 	resizable: true,
      // 	render: (h, params) => {
      // 		return h('span', (params.row.history_pay / 10000).toFixed(2));
      // 	},
      // 	renderHeader: (h, params) => {
      // 		return (this as any).renderHeader(h, '历史转入', '显示玩家注册游戏之后累计转入金额');
      // 	},
      // },
      {
        key: 'history_give',
        align: 'center',
        width: 68,
        resizable: true,
        render: (h, params) => {
          return h('span', (params.row.history_give / 10000).toFixed(2))
        },
        renderHeader: (h, params) => {
          return (this as any).renderHeader(
            h,
            '历史赠送',
            '显示玩家注册游戏之后累计被系统赠送金额'
          )
        }
      },
      // {
      // 	key: 'history_put',
      // 	align: 'center',
      // 	width: 68,
      // 	resizable: true,
      // 	render: (h, params) => {
      // 		return h('span', (params.row.history_put / 10000).toFixed(2));
      // 	},
      // 	renderHeader: (h, params) => {
      // 		return (this as any).renderHeader(h, '历史转出', '显示玩家注册游戏之后累计转出金额');
      // 	},
      // },
      // {
      //   key: 'pid',
      //   align: 'center',
      //   width: 68,
      //   resizable: true,
      //   renderHeader: (h, params) => {
      //     return (this as any).renderHeader(h, '上级ID', '显示玩家的上级代理ID')
      //   }
      // },
      // {
      // 	key: 'vip_level',
      // 	align: 'center',
      // 	width: 68,
      // 	resizable: true,
      // 	renderHeader: (h, params) => {
      // 		return (this as any).renderHeader(h, 'VIP等级', '显示当前玩家的VIP等级信息');
      // 	},
      // },
      // {
      //     key: 'user_tag',
      //     align: 'center',
      //     width: 68,
      //     resizable: true,
      //     renderHeader: (h, params) => {
      //         return (this as any).renderHeader(h, '用户标签', '显示当前玩家的标签');
      //     },
      // },
      {
        key: 'user_desc',
        align: 'center',
        width: 68,
        resizable: true,
        renderHeader: (h, params) => {
          return (this as any).renderHeader(h, '玩家备注', '显示玩家的备注')
        }
      },
      {
        key: 'user_id',
        align: 'center',
        minWidth: 200,
        title: '用户管理',
        render: (h, params) => {
          return h('div', [
            // h(
            //     'Button',
            //     {
            //         props: { type: 'primary' },
            //         style: { margin: '2px', padding: '3px 2px' },
            //         on: {
            //             click: () => {
            //                 this.userTagDetails.show = true;
            //                 this.userTagDetails.data = (this as any).copyData(params.row);
            //             },
            //         },
            //     },
            //     '修改标签'
            // ),
            h(
              'Button',
              {
                props: { type: 'primary' },
                style: { margin: '2px', padding: '3px 2px' },
                on: {
                  click: () => {
                    this.Userdetails.show = true
                    this.userInfo.obj = params.row
                    this.GetUserRegister()
                  }
                }
              },
              '注册详情'
            ),
            h(
              'Button',
              {
                props: { type: 'primary' },
                style: { margin: '2px', padding: '3px 2px' },
                on: {
                  click: () => {
                    this.userInfo.obj = params.row
                    this.UserBind.show = true
                    this.getUserBindInfo()
                  }
                }
              },
              '财务信息'
            ),
            h(
              'Button',
              {
                props: { type: 'primary' },
                style: { margin: '2px', padding: '3px 2px' },
                on: {
                  click: () => {
                    this.userInfo.show = true
                    this.userInfo.tabName = '1'
                    this.userInfo.obj = params.row
                    this.GetUserBaseInfo()
                  }
                }
              },
              '更多信息'
            )
          ])
        }
      }
    ],
    page: 1,
    limit: 10,
    total: 0,
    pageSizes: [10, 20, 30, 40]
  }
  //更多信息
  userInfo = {
    show: false,
    tabName: '1',
    obj: {},
    //基础信息
    userBaseInfo: {},
    //登录日志
    Loginlog: {
      show: false,
      data: [],
      column: [
        { key: 'time', title: '登录时间', align: 'center' },
        { key: 'login_ip', title: '登录IP', align: 'center' },
        { key: 'login_info', title: '登录IP所在地', align: 'center' },
        {
          key: 'os_version',
          title: '玩家登录设备',
          align: 'center',
          render: (h, params) => {
            let obj = JSON.parse(params.row.login_detail)
            return h('span', obj.device.device_id)
          }
        },
        {
          key: 'user_type',
          title: '登录方式',
          align: 'center',
          render: (h, params) => {
            let arr = ['未知', '游客', '手机登录', '微信登录', '第三方账号登录']
            return h('span', arr[params.row.user_type])
          }
        },
        {
          key: 'user_type',
          title: '详情',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary'
                  },
                  style: {
                    margin: '2px',
                    padding: '3px 10px'
                  },
                  on: {
                    click: () => {
                      this.userInfo.Loginlog.show = true
                      this.userInfo.Loginlog.login_detail =
                        params.row.login_detail
                    }
                  }
                },
                '登录详情'
              )
            ])
          }
        }
      ],
      login_detail: '',
      total: 10,
      limit: 15,
      pageSizes: [15, 30, 45, 60],
      page: 1
    },
    //推广奖励
    Percent: {
      data: [],
      wxculmn: [
        {
          key: 'total_send_point',
          align: 'center',
          render: (h, params) => {
            return h('span', (params.row.total_send_point / 10000).toFixed(2))
          },
          renderHeader: (h, params) => {
            return (this as any).renderHeader(
              h,
              '累计业绩返利',
              '显示该用户直营业绩返利+其他玩家业绩返利之和'
            )
          }
        },
        {
          key: 'unter_send_point',
          align: 'center',
          render: (h, params) => {
            return h('span', (params.row.unter_send_point / 10000).toFixed(2))
          },
          renderHeader: (h, params) => {
            return (this as any).renderHeader(
              h,
              '直营业绩返利',
              '显示该用户直营玩家业绩返利金额'
            )
          }
        },
        {
          key: 'team_send_point',
          align: 'center',
          render: (h, params) => {
            return h('span', (params.row.team_send_point / 10000).toFixed(2))
          },
          renderHeader: (h, params) => {
            return (this as any).renderHeader(
              h,
              '其他玩家业绩返利',
              '显示该用户其他玩家业绩返利金额'
            )
          }
        }
      ],
      wxculmn1: [
        {
          key: 'send_time',
          title: '返利发放时间',
          align: 'center',
          minWidth: 120
        },
        {
          key: 'unter_percent',
          title: '直营玩家业绩',
          align: 'center',
          render: (h, params) => {
            return h('span', (params.row.unter_percent / 10000).toFixed(2))
          }
        },
        {
          key: 'unter_commi',
          title: '直营业绩佣金',
          align: 'center',
          render: (h, params) => {
            return h('span', (params.row.unter_commi / 10000).toFixed(2))
          }
        },
        {
          key: 'team_percent',
          title: '其他玩家业绩',
          align: 'center',
          render: (h, params) => {
            return h('span', (params.row.team_percent / 10000).toFixed(2))
          }
        },
        {
          key: 'team_commi',
          title: '其他玩家业绩返利',
          align: 'center',
          render: (h, params) => {
            return h('span', (params.row.team_commi / 10000).toFixed(2))
          }
        }
      ],
      culmn: [
        {
          key: 'total_send_point',
          title: '累计发放给玩家的税收返利',
          align: 'center',
          render: (h, params) => {
            return h('span', (params.row.total_send_point / 10000).toFixed(2))
          }
        },
        {
          key: 'self_send_point',
          title: '自营税收返利',
          align: 'center',
          render: (h, params) =>
            h('span', (params.row.self_send_point / 10000).toFixed(2))
        },
        {
          key: 'unter_send_point',
          title: '直属玩家返利',
          align: 'center',
          render: (h, params) =>
            h('span', (params.row.unter_send_point / 10000).toFixed(2))
        },
        {
          key: 'team_send_point',
          title: '其他玩家返利',
          align: 'center',
          render: (h, params) =>
            h('span', (params.row.team_send_point / 10000).toFixed(2))
        }
      ],
      data1: [],
      culmn1: [
        { key: 'send_time', title: '返利发放时间', align: 'center' },
        {
          key: 'self_percent',
          title: '自营税收',
          align: 'center',
          render: (h, params) =>
            h('span', (params.row.self_percent / 10000).toFixed(2))
        },
        {
          key: 'self_commt',
          title: '自营税收返利',
          align: 'center',
          render: (h, params) =>
            h('span', (params.row.self_percent / 10000).toFixed(2))
        },
        {
          key: 'unter_percent',
          title: '直属玩家税收',
          align: 'center',
          render: (h, params) =>
            h('span', (params.row.self_percent / 10000).toFixed(2))
        },
        {
          key: 'unter_commi',
          title: '直属玩家返利',
          align: 'center',
          render: (h, params) =>
            h('span', (params.row.self_percent / 10000).toFixed(2))
        },
        {
          key: 'team_percent',
          title: '其他玩家税收',
          align: 'center',
          render: (h, params) =>
            h('span', (params.row.team_percent / 10000).toFixed(2))
        },
        {
          key: 'team_commi',
          title: '其他玩家返利',
          align: 'center',
          render: (h, params) =>
            h('span', (params.row.team_commi / 10000).toFixed(2))
        },
        {
          key: 'total_commi',
          title: '总返利金额',
          align: 'center',
          render: (h, params) =>
            h('span', (params.row.total_commi / 10000).toFixed(2))
        }
      ],
      ctype: 1,
      total: 0,
      limit: 10,
      pageSizes: [10, 20, 30, 40],
      page: 1
    },
    //推广日志
    Promotion: {
      data: [],
      dataTime: [
        new Date(new Date().setHours(0, 0, 0, 0) - 6 * 24 * 3600 * 1000),
        (this as any).getCurrentZeroDay()
      ],
      unter_num: 0,
      team_num: 0,
      all_num: 0,
      column: [
        { key: 'time', title: '日期', align: 'center' },
        {
          key: 'new_agent_num',
          title: '新增直属玩家',
          align: 'center',
          sortable: true
        },
        {
          key: 'new_team_num',
          title: '新增其他玩家',
          align: 'center',
          sortable: true
        },
        {
          key: 'nteam_num',
          title: '团队人数',
          align: 'center',
          render: (h, params) => {
            let str = params.row.new_agent_num + params.row.new_team_num
            return h('span', str)
          }
        }
      ]
    },
    //转入日志
    RechargeLog: {
      time: [
        new Date(new Date().setHours(-696, 0, 0, 0)),
        (this as any).getCurrentZeroDay()
      ],
      column: [
        {
          key: 'time',
          title: '转入时间',
          align: 'center',
          width: '200'
        },
        {
          key: 'pay_type',
          title: '转入方式',
          align: 'center',
          render: (h, params) => {
            let arr = [
              '公司入账',
              '线上转入',
              '银行卡转入',
              '赠送转入',
              '',
              '专享闪付'
            ]
            let str = arr[params.row.pay_type - 1]
            return h('span', str)
          }
        },
        {
          key: 'point',
          title: '转入金额',
          align: 'center',
          sortable: true,
          sortMethod: function(a, b, type) {},
          render: (h, params) => {
            return h('span', params.row.point / 10000)
          }
        },
        { key: 'pay_ip', title: '转入所在IP', align: 'center' },
        { key: 'devices', title: '转入设备', align: 'center' },
        {
          key: 'opt',
          title: '操作人或转入通道',
          align: 'center',
          width: '200'
        }
      ],
      data: [],
      total: 0,
      limit: 15,
      pageSizes: [15, 30, 45, 60],
      page: 1,
      user_id: '',
      sort: 0
    }
  }
  //用户详情
  Userdetails = {
    show: false,
    bol: false,
    user_id: '',
    data: [],
    column: [
      {
        key: 'user_id',
        title: '玩家信息',
        align: 'center',
        render: (h, params) => {
          let str = params.row.name + '(' + params.row.user_id + ')'
          return h('span', str)
        }
      },
      { key: 'phone', title: '绑定手机号', align: 'center' },
      { key: 'wx_account', title: '绑定微信信息', align: 'center' },
      { key: 'mac_account', title: '绑定硬件信息', align: 'center' }
    ],
    column1: [
      { key: 'register_time', title: '注册时间', align: 'center' },
      { key: 'register_ip', title: '注册IP', align: 'center' },
      { key: 'register_addr', title: '注册IP所在地', align: 'center' },
      { key: 'register_city', title: '玩家注册地址', align: 'center' }
    ],
    column2: [{ key: 'reg_info', title: '注册途径', align: 'center' }]
  }
  //财务信息
  UserBind = {
    show: false,
    columns1: [
      { key: 'entrus_bank_name', title: '开户银行', align: 'center' },
      { key: 'account', title: '银行卡号', align: 'center' },
      { key: 'account_user', title: '姓名', align: 'center' },
      {
        key: 'bank_provcince',
        title: '开户省市',
        align: 'center',
        render: (h, params) => {
          let str = params.row.bank_provcince + '/' + params.row.bank_city
          return h('span', str)
        }
      },
      { key: 'bank_name', title: '开户支行', align: 'center' }
    ],
    columns2: [
      { key: 'ali_account', title: '支付宝账号', align: 'center' },
      { key: 'ali_user', title: '支付宝姓名', align: 'center' }
    ],
    columns3: [
      {
        key: 'over_sea_entrus_bank_name',
        title: '开户银行',
        align: 'center'
      },
      { key: 'over_sea_account', title: '银行卡号', align: 'center' },
      { key: 'over_sea_account_user', title: '姓名', align: 'center' }
    ],
    data: []
  }
  moreModal = {
    show: false,
    params: {
      app_id: 0,
      phones: [],
      content: '',
      upload_content: '',
      type: 0
    },
    rules: {
      app_id: [
        {
          required: true,
          trigger: 'change',
          validator: (this as any).simpleVerify('请选择盘口')
        }
      ]
    }
  }
  openModalMore() {
    this.moreModal.show = true
    this.moreModal.params = {
      app_id: 0,
      phones: [],
      content: '',
      upload_content: '',
      type: 0
    }
  }
  updateUserTag() {
    let from: any = this.userTagDetails.data
    from.type = 16
    let params = this.paramsList(
      from.platid,
      from.app_id,
      from,
      'UpdateUserInfo'
    )
    TransTopReq(params).then(res => {
      this.userTagDetails.show = false
      this.userTagDetails.data = <any>{}
      this.TransTopReq()
    })
  }
  //关闭定时器
  closeTimer() {
    this.loading = false
    clearTimeout(this.TransTopReqTimer)
    this.TransTopReqTimer = null
  }
  //批量请求开启定时器8秒超时
  openTimer() {
    this.closeTimer()
    this.loading = true
    this.TransTopReqTimer = setTimeout(() => {
      this.loading = false
    }, 6000)
  }
  async TransTopReq() {
    if (this.loading) return
    this.table.params.param._param.phone_code = Number(
      this.table.params.param._param.phone_code1
    )
    this.openTimer()
    let allList: any = (this as any).getAllHttpAppid(this.table.params)
    this.table.total_num = 0
    this.table.total_pay = 0
    this.table.total_put = 0
    this.table.data = []
    let dateMap: any = {}
    let httpList: any = []
    let loadingArr = [...allList]
    for (let i = 0, len = allList.length; i < len; i++) {
      let app_id = allList[i]
      let app_name = ''
      let platid = 0
      let item: any = (this as any).app_list.find(
        (el: any) => el.appid == app_id
      )
      if (item) {
        app_name = item.appName
        platid = item.platform
      }
      this.table.params.platid = platid
      this.table.params.app_id = app_id
      this.table.params.app_name = app_name
      this.table.params.param._param.app_id = app_id
      let param = (this as any).copyData(this.table.params)
      param.param._param.user_id = Number(
        this.table.params.param._param.user_id
      )
      httpList.push(param)
    }
    for (let s = 0; s < 5; s++) {
      this.toHttp(httpList, dateMap, loadingArr)
    }
  }
  async toHttp(httpList, dateMap, loadingArr) {
    if (httpList.length > 0) {
      let param = httpList[0]
      httpList.shift()
      TransTopReq(param)
        .then(res1 => {
          this.table.total_num += res1._param.total
          this.table.total_pay += res1._param.total_pay
          this.table.total_put += res1._param.total_put
          let param1 = this.paramsList(
            param.platid,
            param.app_id,
            res1._param,
            'GetUserList2'
          )
          TransTopReq(param1)
            .then(res => {
              let list = res._param.list || []
              list.map(item => {
                item.ctype = res._param.ctype
                item.platid = param.platid
                item.app_id = param.app_id
                ;(this.table.data as any).push(item)
                this.table.total = this.table.data.length
              })
              this.requestCallBack(loadingArr)
              this.toHttp(httpList, dateMap, loadingArr)
            })
            .catch(err => {
              this.requestCallBack(loadingArr)
              this.toHttp(httpList, dateMap, loadingArr)
            })
        })
        .catch(err => {
          this.requestCallBack(loadingArr)
          this.toHttp(httpList, dateMap, loadingArr)
        })
    }
  }

  requestCallBack(list: any) {
    if (list.length == 0) {
      this.closeTimer()
    }
  }
  //分组变化清空盘口选择项
  updateSelect() {
    this.table.params.app_ids = []
  }
  //
  paramsList(platform, app_id, obj, func) {
    let _param = {
      mod: 'root',
      platid: platform,
      app_id: app_id,
      param: {
        _mod: 'manager',
        _func: func,
        _param: obj
      }
    }
    return _param
  }
  //tabs切换
  tabsNname(data) {
    if (data == 1) {
      this.GetUserBaseInfo()
    } else if (data == 2) {
      this.GetUserLoginList(1)
    } else if (data == 3) {
      this.GetUserPercent()
    } else if (data == 4) {
      this.GetUserShare()
    } else if (data == 5) {
      this.GetUserPayList(1)
    }
  }

  //GetUserBaseInfo
  //获取用户更多信息//基础信息
  GetUserBaseInfo() {
    let obj = {
      app_id: this.userInfo.obj['app_id'],
      user_id: this.userInfo.obj['user_id']
    }
    let param = this.paramsList(
      this.userInfo.obj['platid'],
      this.userInfo.obj['app_id'],
      obj,
      'GetUserBaseInfo'
    )
    TransTopReq(param).then(res => {
      this.userInfo.userBaseInfo = res['_param'] || {}
    })
  }
  getAppInfo(item: any) {
    return (
      (this as any).app_list.find((el: any) => el.appid == item.app_id) || {}
    )
  }
  getPlatInfo(item: any) {
    return (
      (this as any).plat_list.find((el: any) => el.id == item.platid) || {
        name: ''
      }
    )
  }
  //获取用户更多信息//登录日志
  GetUserLoginList(num?) {
    if (num) {
      this.userInfo.Loginlog.page = 1
    }
    let obj = {
      app_id: this.userInfo.obj['app_id'],
      user_id: this.userInfo.obj['user_id'],
      page: this.userInfo.Loginlog.page,
      limit: this.userInfo.Loginlog.limit
    }
    let param = this.paramsList(
      this.userInfo.obj['platid'],
      this.userInfo.obj['app_id'],
      obj,
      'GetUserLoginList'
    )
    TransTopReq(param).then(res => {
      this.userInfo.Loginlog.data = res['_param'].list || []
      this.userInfo.Loginlog.total = res['_param'].total
    })
  }
  //分页登录日志
  Loginlimit(limit) {
    this.userInfo.Loginlog.limit = limit
    this.userInfo.Loginlog.page = 1
    this.GetUserLoginList()
  }
  Loginpage(page) {
    this.userInfo.Loginlog.page = page
    this.GetUserLoginList()
  }

  //推广奖励
  GetUserPercent(num?) {
    if (num) {
      this.userInfo.Percent.page = 1
    }
    this.userInfo.Percent.ctype = this.userInfo.obj['ctype']
    let obj = {
      app_id: this.userInfo.obj['app_id'],
      user_id: this.userInfo.obj['user_id'],
      page: this.userInfo.Percent.page,
      limit: this.userInfo.Percent.limit
    }
    if (this.userInfo.Percent.ctype == 1) {
      let param = this.paramsList(
        this.userInfo.obj['platid'],
        this.userInfo.obj['app_id'],
        obj,
        'GetUserPercentRecord'
      )
      TransTopReq(param).then(res => {
        this.userInfo.Percent.data = []
        ;(this.userInfo.Percent.data as any).push(res['_param'])
        this.userInfo.Percent.data1 = res['_param'].list || []
        this.userInfo.Percent.total = res['_param'].total
      })
    } else {
      let param = this.paramsList(
        this.userInfo.obj['platid'],
        this.userInfo.obj['app_id'],
        obj,
        'GetUserDayAgentRecord'
      )
      TransTopReq(param).then(res => {
        this.userInfo.Percent.data = []
        ;(this.userInfo.Percent.data as any).push(res['_param'])
        this.userInfo.Percent.data1 = res['_param'].list || []
        this.userInfo.Percent.total = res['_param'].total
      })
    }
  }
  Percentlimit(limit) {
    this.userInfo.Percent.page = 1
    this.userInfo.Percent.limit = limit
    this.GetUserPercent()
  }
  Percentpage(page) {
    this.userInfo.Percent.page = page
    this.GetUserPercent()
  }
  readExcel(e) {
    const files = e.target.files
    if (files[0].size > 1024 * 1024 * 1) {
      this.$Message.error('上传文件内容不能大于1M')
      return false
    }
    const fileReader = new FileReader()
    // let nametxt = files[0].name.substring(0,files[0].name.length-4)
    fileReader.onload = (ev: any) => {
      try {
        let data = ev.target.result
        console.log(data, this.moreModal.params.app_id)
        this.moreModal.params.upload_content = data
        this.$Message.success('文件解析成功')
        if (this.moreModal.params.app_id) {
          this.$Modal.confirm({
            title: '立即查询?',
            onOk: () => {
              this.toFind()
            }
          })
        }
      } catch (e) {
        return false
      }
    }
    fileReader.readAsText(files[0], 'gb2312')
  }
  closeMoreModal() {
    this.moreModal.show = false
    this.moreModal.params = {
      app_id: 0,
      phones: [],
      content: '',
      upload_content: '',
      type: 0
    }
  }
  toFind() {
    ;(this.$refs.phone_ref as any).validate(val => {
      if (val) {
        let params: any = { ...this.moreModal.params }
        if (params.type == 0) {
          if (this.moreModal.params.content) {
            var list: any = Array.from(
              new Set(
                this.moreModal.params.content
                  .replace(new RegExp(',', 'g'), '\n')
                  .replace(new RegExp('，', 'g'), '\n')
                  .replace(new RegExp('\r\n', 'g'), '\n')
                  .split('\n')
                  .filter(el => el)
              )
            )
            params.phones = list
          } else {
            return this.$Message.error('请输入手机号')
          }
        }
        if (params.type == 1) {
          if (this.moreModal.params.upload_content) {
            var list: any = Array.from(
              new Set(
                this.moreModal.params.upload_content
                  .replace(new RegExp(',', 'g'), '\n')
                  .replace(new RegExp('，', 'g'), '\n')
                  .replace(new RegExp('\r\n', 'g'), '\n')
                  .split('\n')
                  .filter(el => el)
              )
            )
            params.phones = list
          } else {
            return this.$Message.error('请先上传文件')
          }
        }
        let app = (this as any).app_list.find(el => el.appid == params.app_id)
        if (app) {
          params.platid = app.platform
          TransTopReq({
            mod: 'root',
            platid: app.platform,
            app_id: params.app_id,
            param: {
              _mod: 'manager',
              _func: 'GetUserDataByPhones',
              _param: params
            }
          }).then(res => {
            this.closeMoreModal()
            let data = res._param.list || []
            let app_name = app.appName
              ? `${app.appName}`.replace('棋牌', '').replace('娱乐', '')
              : ''
            if (data.length > 0) {
              let str =
                '盘口,UID,电话号码,最后转入时间,最后投注时间,最后活跃时间\n'
              data.forEach(item => {
                str += `${app_name},${item.uid},${item.phone},${item.last_pay_date},${item.last_bet_date},${item.last_active_date}\n`
              })
              ;(this as any).noTableCsvToXlsx(str, `${app_name} 信息`)
            } else {
              this.$Message.error('无数据')
            }
          })
        }
      }
    })
  }
  //推广日志
  GetUserShare() {
    let [stime, etime] = this.userInfo.Promotion.dataTime
    let obj = {
      app_id: this.userInfo.obj['app_id'],
      user_id: this.userInfo.obj['user_id'],
      stime: (this as any).getSecond(stime),
      etime: (this as any).getSecond(etime, false)
    }
    let param = this.paramsList(
      this.userInfo.obj['platid'],
      this.userInfo.obj['app_id'],
      obj,
      'GetUserShareList'
    )
    TransTopReq(param).then(res => {
      this.userInfo.Promotion.data = res._param.list || []
      this.userInfo.Promotion.unter_num = res._param.unter_num
      this.userInfo.Promotion.team_num = res._param.team_num
      this.userInfo.Promotion.all_num = res._param.all_num
    })
  }

  //转入日志
  GetUserPayList(num?) {
    if (num) this.userInfo.RechargeLog.page = 1
    let [stime, etime] = this.userInfo.RechargeLog.time
    let obj = {
      app_id: this.userInfo.obj['app_id'],
      user_id: this.userInfo.obj['user_id'],
      page: this.userInfo.RechargeLog.page,
      limit: this.userInfo.RechargeLog.limit,
      sort: this.userInfo.RechargeLog.sort,
      stime: (this as any).getSecond(stime),
      etime: (this as any).getSecond(etime, false)
    }
    let param = this.paramsList(
      this.userInfo.obj['platid'],
      this.userInfo.obj['app_id'],
      obj,
      'GetUserPayList'
    )
    TransTopReq(param).then(res => {
      this.userInfo.RechargeLog.data = res['_param'].list || []
      this.userInfo.RechargeLog.total = res['_param'].total
    })
  }
  RechargeLoglimit(limit) {
    this.userInfo.RechargeLog.limit = limit
    this.userInfo.RechargeLog.page = 1
    this.GetUserPayList()
  }
  RechargeLogpage(page) {
    this.userInfo.RechargeLog.page = page
    this.GetUserPayList()
  }
  //注册详情
  GetUserRegister() {
    let obj = {
      app_id: this.userInfo.obj['app_id'],
      user_id: this.userInfo.obj['user_id']
    }
    let param = this.paramsList(
      this.userInfo.obj['platid'],
      this.userInfo.obj['app_id'],
      obj,
      'GetUserRegisterInfo'
    )
    TransTopReq(param).then(res => {
      this.Userdetails.data = []
      ;(this.Userdetails.data as any).push(res['_param'])
    })
  }
  //GetUserBindInfo
  // 财务信息
  getUserBindInfo() {
    let obj = {
      app_id: this.userInfo.obj['app_id'],
      user_id: this.userInfo.obj['user_id']
    }
    let param = this.paramsList(
      this.userInfo.obj['platid'],
      this.userInfo.obj['app_id'],
      obj,
      'GetUserBindInfo'
    )
    TransTopReq(param).then(res => {
      this.UserBind.data = []
      ;(this.UserBind.data as any).push(res._param)
    })
  }
  //判断查询是否可以点击
  funcDis() {
    let {
      user_id,
      register_ip,
      last_ip,
      mac_account,
      bank_card,
      phone_code1,
      phone,
      card_name,
      ali_card
    } = this.table.params.param._param
    return !(
      user_id ||
      register_ip ||
      last_ip ||
      mac_account ||
      bank_card ||
      phone_code1 ||
      phone ||
      card_name ||
      ali_card
    )
  }
  initFunc() {
    let arr: any = [(this as any).getinitPlatId()]
    this.table.params.platids = arr
  }
  widthResize(val1, val2, val3) {
    this.tableSetting[val3.key] = val1
    setTableSetting(tableSettingModel.userList, this.tableSetting)
  }
  initTableSetting() {
    this.tableSetting = getTableSetting(tableSettingModel.userList)
    this.table.columns.forEach(element => {
      if (element.key && this.tableSetting[element.key]) {
        element.width = this.tableSetting[element.key]
      }
    })
  }
  created() {
    this.initTableSetting()
    this.initFunc()
  }
  mounted() {
    ;(this.$refs.uploads as any).addEventListener('change', e => {
      //绑定监听表格导入事件
      this.readExcel(e)
    })
  }
}
